import {ReviewCityType} from '../../../../../service/reivew-analysis/review-cities/review-cities-type';

export const citiesDefaultPageSize = 25;
export const citiesPageSizeOptions: [number, ...Array<number>] = [10, 25, 50, 100];

export const emptyReviewCity: ReviewCityType = {
    cityId: -1,
    cityName: '',
    total: 0,
    avgRating: 0,
    replied: 0,
    repliedPercent: 0,
    avgResponseSpeed: null,
    sentiment: {
        positive: 0,
        neutral: 0,
        negative: 0,
        unspecified: 0,
    },
    trendByThreeMonths: [],
};
